"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ClickOutside = function ClickOutside(props) {
  var node = (0, _react.useRef)();
  var handleClick = function handleClick(e) {
    if (node.current.contains(e.target)) {
      // inside click
      return;
    }
    // outside click
    if (props.onClick) props.onClick();
  };
  (0, _react.useEffect)(function () {
    // add when mounted
    document.addEventListener('click', handleClick);
    // return function to be called when unmounted
    return function () {
      document.removeEventListener('click', handleClick);
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: node
  }, props.children);
};
ClickOutside.propTypes = {
  onClick: _propTypes["default"].func.isRequired,
  children: _propTypes["default"].any.isRequired
};
var _default = exports["default"] = ClickOutside;